export const MIN_CHARS_PERSON_NAMES = 2
export const MAX_CHARS_PERSON_NAMES = 40
export const MIN_AGE_TO_REGISTER = 9
export const MIN_AGE_TO_REGISTER_FAST_TRACK = 7
export const MIN_CHARS_PERSONA_DETAIL = 1
export const MAX_CHARS_PERSONA_DETAIL = 50
export const MIN_CHARS_WHERE_DID_YOU_HEAR_DETAIL = 0
export const MAX_CHARS_WHERE_DID_YOU_HEAR_DETAIL = 100
